<template>
    <section class="w-full mb-10">
        <div v-if="showMap">
            <!-- <google-map :location="address" /> -->
            <iframe
                title="Karta"
                width="100%"
                height="450"
                frameborder="0"
                style="border: 0"
                :src="
                    'https://www.google.com/maps/embed/v1/place?key=AIzaSyAr2_o8vh0SgIBJrfcJMjp-qJGVCBRez0E&q=' +
                    address +
                    ', Väsrerås'
                "
                allowfullscreen
            >
            </iframe>
        </div>

        <div v-else class="relative cursor-pointer" @click="showMap = true">
            <div class="blur-sm opacity-75">
                <img
                    src="https://abg-prototyping.sogetivasteras.se/labs/vacancy/img/map.png"
                    class="w-full"
                    alt="Platshållarbild för karta"
                />
            </div>

            <div
                class="flex items-center justify-center blur-none"
            >
                <mimer-button text="Visa på karta"></mimer-button>
            </div>
        </div>
    </section>
</template>

<script>
import { MimerButton } from 'mimer-components';

export default {
    name: 'MimerMap',
    data() {
        return {
            showMap: false,
        };
    },
    props: {
        address: String,
    },
    components: {
        MimerButton,
    },
};
</script>
